(() => {
  'use strict';

  function initJudgeMeTranslation() {
    const translations = new Map([
      ['Customer Reviews', 'Avaliações de clientes'],
      ['Be the first to write a review', 'Seja o primeiro a escrever uma avaliação'],
      ['Write a review', 'Escrever uma avaliação']
    ]);

    const selector = '[class*="jdgm"], [id^="judgeme"], [id*="judgeme"]';
    const pendingRoots = new Set();
    let scheduled = false;

    const translateAttributes = (scope) => {
      const elements = [];

      if (scope.matches?.('input, textarea, button, [aria-label], [title]')) {
        elements.push(scope);
      }

      scope
        .querySelectorAll?.('input, textarea, button, [aria-label], [title]')
        .forEach((element) => elements.push(element));

      elements.forEach((element) => {
        const fields = [
          ['value', element.value?.trim()],
          ['placeholder', element.placeholder?.trim()],
          ['aria-label', element.getAttribute('aria-label')?.trim()],
          ['title', element.getAttribute('title')?.trim()]
        ];

        fields.forEach(([attribute, original]) => {
          if (!original || !translations.has(original)) return;

          const translated = translations.get(original);

          if (attribute === 'value') {
            element.value = translated;
          } else if (attribute === 'placeholder') {
            element.placeholder = translated;
          } else {
            element.setAttribute(attribute, translated);
          }
        });
      });
    };

    const translateScope = (scope) => {
      if (!(scope instanceof Element)) return;

      const walker = document.createTreeWalker(scope, NodeFilter.SHOW_TEXT);
      let node;

      while ((node = walker.nextNode())) {
        const original = node.nodeValue.trim();
        const translated = translations.get(original);

        if (translated) {
          node.nodeValue = node.nodeValue.replace(original, translated);
        }
      }

      translateAttributes(scope);
    };

    const collectJudgeMeRoots = (root) => {
      if (!(root instanceof Element) && root !== document) return;

      if (root instanceof Element && root.matches(selector)) {
        pendingRoots.add(root);
      }

      root.querySelectorAll?.(selector).forEach((element) => {
        pendingRoots.add(element);
      });
    };

    const flush = () => {
      scheduled = false;
      pendingRoots.forEach(translateScope);
      pendingRoots.clear();
    };

    const scheduleFlush = () => {
      if (scheduled) return;
      scheduled = true;

      if ('requestIdleCallback' in window) {
        window.requestIdleCallback(flush, { timeout: 600 });
      } else {
        window.setTimeout(flush, 50);
      }
    };

    collectJudgeMeRoots(document);
    scheduleFlush();

    const observer = new MutationObserver((mutations) => {
      const previousSize = pendingRoots.size;

      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node instanceof Element) {
            collectJudgeMeRoots(node);
          }
        });
      });

      if (pendingRoots.size > previousSize) {
        scheduleFlush();
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  function initBackToTop() {
    const button = document.getElementById('tomauto-back-to-top');
    if (!button || button.dataset.ready === 'true') return;

    button.dataset.ready = 'true';

    let frame = 0;

    const update = () => {
      frame = 0;
      button.classList.toggle('is-visible', window.scrollY > 450);
    };

    const schedule = () => {
      if (frame) return;
      frame = window.requestAnimationFrame(update);
    };

    button.addEventListener('click', () => {
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      window.scrollTo({
        top: 0,
        behavior: reduceMotion ? 'auto' : 'smooth'
      });
    });

    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('pageshow', schedule, { passive: true });

    schedule();
  }

  function init() {
    initJudgeMeTranslation();
    initBackToTop();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
